import request from '@/utils/request';

export function getStoreWarningInfo(params) {
  return request({
    url: `/message-server/markets/${params.marketID}/messages`,
    method: 'get',
    params
  });
}
export function getEnterpriseWarningInfo(params) {
  return request({
    url: `/message-server/enterprises/${params.eid}/messages`,
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/warningInfo.js